import * as axios from '../../helpers/customAxios';
import { API_BASE } from './constants';
import { Group, User } from './types';

export const API = {
	searchIdentity: (value: string, exceptions?: string): Promise<User[]> =>
		axios.get({
			url: `${API_BASE.USER_SEARCH}`,
			config: { params: { term: value, limit: 25, exceptions } },
		}),
	getGroupDetails: (groupId: string): Promise<Group> =>
		axios.get({ url: `${API_BASE.WORKFLOW_GROUP_DETAILS}/${groupId}` }),
	removeGroup: (formData: unknown) =>
		axios.post({
			url: API_BASE.WORKFLOW_GROUP_REMOVE,
			data: formData,
			config: { headers: axios.defaultFormHeaders },
		}),
	saveGroup: (formData: unknown): Promise<string> =>
		axios.post({
			url: API_BASE.WORKFLOW_GROUP_SAVE,
			data: formData,
			config: { headers: axios.defaultFormHeaders },
		}),
	listGroups: (): Promise<Group[]> => axios.get({ url: API_BASE.WORKFLOW_GROUPS_LIST }),
};
